import store from '../data/store'
import { ConvertableFromApi } from "./ConvertableFromApi";
import {ajaxPost, ajaxDelete} from "../data/ajax"
import {Helper} from "../models/HelperClasses";


export class GraphUserModel extends ConvertableFromApi<GraphUserModel> {
  
  businessPhones!: string[];
  displayName!: string;
  givenName!: string;
  mail!: string;
  mobilePhone!: string;
  officeLocation!: string;
  surname!: string;
  userPrincipalName!: string;
  department!: string;
  id!: string;
  jobTitle?: any;
  preferredLanguage?: any;

  constructor(data?: any) {
    super(data);
    if(!this.objectFromApi){
      return;
    }
    
    this.businessPhones = this.objectFromApi.businessPhones;
    this.displayName = this.objectFromApi.displayName;
    this.givenName = this.objectFromApi.givenName;
    this.mail = this.objectFromApi.mail;
    this.mobilePhone = this.objectFromApi.mobilePhone;
    this.officeLocation = this.objectFromApi.officeLocation;
    this.surname = this.objectFromApi.surname;
    this.userPrincipalName = this.objectFromApi.userPrincipalName;
    this.id = this.objectFromApi.id;
    this.jobTitle = this.objectFromApi.jobTitle;
    this.preferredLanguage = this.objectFromApi.preferredLanguage;
    this.department = this.objectFromApi.department;
  }

  createNew(element: any): GraphUserModel {
    return new GraphUserModel(element);
  }

  async addToWorkspace(groupId: string, workspaceName: string, token: string){
    const url = process.env.VUE_APP_ROOT_API + `User/workspace/${workspaceName}/group/${groupId}/add`;
      var result = await ajaxPost(url, token, this);
      if(result !== null){
        store.commit('addResearcherToWorkspace', this);
        Helper.successToaster(`${this.displayName} has successfully been added to the workspace`);
      }
  }

  async removeFromWorkspace(groupId: string, workspaceName: string, token: string){
    const url = process.env.VUE_APP_ROOT_API + `user/workspace/${workspaceName}/group/${groupId}/remove/${this.id}`;
      var result = await ajaxDelete(url, token);
      if(result !== null){
        store.commit('removeResearcherFromWorkspace', this);
        Helper.successToaster(`${this.displayName} has successfully been removed from the workspace. It will take a few minutes before the researcher is unable to view/access the workspace`);
      }
  }
}
